// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"B4-z","colorTextValue":"C4-z","swatches":"D4-z","collapseLink":"E4-z","isCollapsed":"F4-z","dropdown":"G4-z","disabled":"H4-z"};